export const API_URL = process.env.REACT_APP_API_URL as string;
export const PASSWORD_REMINDER_URL = process.env.REACT_APP_PASSWORD_REMINDER_URL as string;
export const ACCOUNT_CREATE_URL = process.env.REACT_APP_ACCOUNT_CREATE_URL as string;

export const LOGIN_API_URL = '/clientuserlogin';
export const GET_SERIAL_API_URL = '/serial';

export { default as i18n } from './i18n';
export * from './i18n';
